<template>
  <div class="cc align-items-start">
    <CContainer>
      <CRow class="justify-content-center">
        <CCol md="8">
          <CCardGroup>
            <CCard class="p-4" style="background-image: linear-gradient( 135deg, rgb(4, 24, 45) 100%, #fff 100%);">
              <CCardBody>
              <div>
                <CForm v-if="showLoginForm" @submit.prevent>
                <div row class="container row mb-2 mt-0">
                <div class="col-dm-8">
                  <h1 class="text-white">Acessar</h1>                  
                  <p class="text-white">Status PPA.</p>
                </div>
                <div class="col-dm-4 d-block d-sm-none" >
                <img src="../imagess/participa.png" style="width: 5.7rem; position: absolute; transform: rotate(8deg);
                top: 9%; right: 0; margin-right: 38px;">
                </div>


                </div>
                <div style="margin-top: 0.6rem; margin-bottom: 1.7rem;">
                  <CInput
                    placeholder="exemplo@timoteo.com"
                    type="email" 
                    id="email" 
                    v-model="email"
                  >
                    <template #prepend-content><CIcon name="cil-user"/></template>
                  </CInput>
                  <CInput
                    placeholder="Senha"
                    type="password" 
                    id="password" 
                    v-model="password"
                  >
                    <template #prepend-content><CIcon name="cil-lock-locked"/></template>
                  </CInput>
                </div>
                  <CRow class="mt-4">
                    <CCol col="6" class="text-left">
                      <CButton v-on:click="login" color="success" class="px-4">Acessar</CButton>
                      
                    </CCol>
                    <!-- <CCol col="6" class="text-right">
                      <CButton color="dark-light" class="px-0 text-white">Recuperar senha?</CButton>
                      <CButton @click="toggleForm()" color="dark-light" class="px-0 py-0 text-white">Criar conta</CButton>                      
                    </CCol> -->
                  </CRow>
                </CForm>

                <!-- <CForm v-else @submit.prevent>
                <div row class="container row mb-2 mt-0">
                <div class="col-dm-8">
                  <h1 class="text-white">Criar conta</h1>                  
                  <p class="text-white">E preencha seu currículo</p>
                </div>
                <div class="col-dm-4 d-block d-sm-none" >
                <img src="@/assets/img/brasao.svg" style="width: 5.7rem; position: absolute;
                top: 9%; right: 0; margin-right: 38px;">
                </div>


                </div>
                <div style="margin-top: 0.6rem; margin-bottom: 1.7rem;">
                  <CInput
                    placeholder="exemplo@timoteo.com"
                    type="email" 
                    id="email" 
                    v-model="email"
                  >
                    <template #prepend-content><CIcon name="cil-user"/></template>
                  </CInput>
                  <CInput
                    placeholder="Senha"
                    type="password" 
                    id="password" 
                    v-model="password"
                  >
                    <template #prepend-content><CIcon name="cil-lock-locked"/></template>
                  </CInput>
                </div>
                  <CRow class="mt-4 mb-2">
                    <CCol col="6" class="text-left">
                      <CButton v-on:click="register" color="success" class="px-4">Criar</CButton>                      
                    </CCol>
                    <CCol col="6" class="text-right">
                      <CButton @click="toggleForm()" color="dark-light" class="px-0 text-white">Voltar para Login</CButton>                                        
                    </CCol>
                  </CRow>
                </CForm> -->
                </div>
                <CRow>
                  <CCol class="text-left"  style="margin-right: -15px;">
                    <label class="mt-4 mr-0 pr-0 text-white pb-0">Entrar com:</label>
                  </CCol>
                    <CCol col="8" class="text-white" >
                  <div id="social" >                              
                    <CIcon name="cib-google" alt="Google"/> <CIcon class="ml-4" name="cib-facebook" alt="Facebook"/> 
                  </div>
                  </CCol>
                </CRow>
              </CCardBody>
            </CCard> 
            <CCard              
              text-color="sucess"
              class="text-center py-5 d-md-down-none"
              body-wrapper
            > 
              <CCardBody>
              <img class="img2" src="../imagess/participa.png" style=" width: 250px; margin-top: -1rem">                
              </CCardBody>
            </CCard>
          </CCardGroup>
        </CCol>
      </CRow>
    </CContainer>
  </div>
</template>

<script>
import firebase from 'firebase';

export default {
  name: 'Admin',
  data: function() {
    return {
      email: '',
      password: '',
      showLoginForm: true,
    };
  },
  methods: {
    toggleForm() {
      this.showLoginForm = !this.showLoginForm
    },
    login: function(e) {
      firebase
        .auth()
        .signInWithEmailAndPassword(this.email, this.password)
        .then(
          user => {
            //alert(`You are logged in as ${user.email}`);
            this.$router.go({ path: this.$router.path });
          },
          err => {
            alert(err.message);
          }
        );
      e.preventDefault();
    },
    register: function(e) {
      firebase
        .auth()
        .createUserWithEmailAndPassword(this.email, this.password)
        .then(
          user => {
            // console.log(user);
            //alert(`Account Created for ${user.email}`);
            this.$router.go({ path: this.$router.path });
          },
          err => {
            alert(err.message);
          }
        );
      e.preventDefault();
    }
  }
};
</script>

<style scoped>
#social > .c-icon:not(.c-icon-c-s):not(.c-icon-custom-size) {
    width: 2.5rem;
    height: 2.5rem;
    margin-top: 1.5rem;

}

#social > .c-icon:not(.c-icon-c-s):not(.c-icon-custom-size):hover {
  
  width: 2.5rem;
  height: 2.5rem;
  margin-top: 1rem;
}

.cc {
  padding-top: 3.6rem;
  margin-bottom: 2rem;
}
.card {
  background-color: #ebedef;
  border-color: transparent;   
}

.img2 {
  transform: rotate(8deg)
}


</style>

